<script setup>
import {ref, computed} from 'vue'

// 内部的激活状态用 computed 代理
const tabActive = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})

// 接收外部传入的 v-model 值
const props = defineProps({
  modelValue: {
    type: String,
    default: 'zh'
  }
})

const emit = defineEmits(['change'])
// 处理active改变
const handleChange = (type) => {
  tabActive.value = type
  emit('change', type)
}
</script>

<template>
  <div class="i18nTab_box flex cursor-pointer">
    <div class="cn_box" :class="tabActive === 'zh' ? 'is_tabs_active cn_box' : 'cn_box'" @click="handleChange('zh')">中文</div>
    <div class="box_line"></div>
    <div class="en_box" :class="tabActive === 'en' ? 'is_tabs_active en_box' : 'en_box'" @click="handleChange('en')">English</div>
  </div>
</template>

<style lang="scss" scoped>
.i18nTab_box {
  background-color: #fff;

}
.cn_box {
  height: 44px;
  padding: 0 17px 0 20px;
  line-height: 44px;
  /* 右边向左斜 15° */
  clip-path: polygon(
          0 0,           /* A: 左上 */
          100% 0,        /* B: 右上 (保持不变) */
          calc(100% - 9px) 100%,  /* C: 右下往左收 20px */
          0 100%         /* D: 左下 */
  );
  border-radius: 15px 0 0 15px;
  border: 1px solid #E8E8E9;
  font-weight: 500;
  font-size: 14px;
  color: #6F717D;
  text-wrap: nowrap;
  z-index: 2;
}
.box_line {
  width: 10px;
  height: 44px;
  background-color: #E8E8E9;
  /* 右边向左斜 15° */
  clip-path: polygon(
          9px 0,           /* A: 左上 */
          100% 0,        /* B: 右上 (保持不变) */
          calc(100% - 9px) 100%,  /* C: 右下往左收 20px */
          0 100%         /* D: 左下 */
  );
  z-index: 2;
  margin-left: -9px;
}

.cn_box:hover {
  color: #796CB4;
  transition: .3s;
}
.en_box {
  height: 44px;
  box-sizing: border-box;
  padding: 0 20px 0 20px;
  line-height: 44px;
  clip-path: polygon(
          8px 0,      /* A: 左上往右收 20px */
          100% 0,      /* B: 右上 */
          100% 100%,   /* C: 右下 */
          0 100%       /* D: 左下 */
  );
  border-radius: 0 15px 15px 0;
  border: 1px solid #E8E8E9;
  font-weight: 500;
  font-size: 14px;
  color: #6F717D;
  z-index: 2;
  margin-left: -10px;
}
.en_box:hover {
  color: #796CB4;
  transition: .3s;
}
.is_tabs_active {
  background: #F5F7FA!important;
  font-weight: bold;
  font-size: 14px;
  color: #796CB4;
  z-index: 1;
}
</style>
